/** @format */
import { css } from 'styled-components';

import {
    LIST_GAP,
    LIST_ITEM_HEIGHT,
    LIST_PADDING_TOP,
    getDisplay,
} from './style-helpers';
import { StyledProductBoxProps } from './types';

const baseStyles = ({ isCollapsable = false }: StyledProductBoxProps) => css`
    display: ${getDisplay(isCollapsable)};
    flex-direction: column;
    justify-content: center;

    .list-animated-container {
        overflow: hidden;
    }

    .list-container {
        display: grid;
        width: 100%;
        padding-top: ${LIST_PADDING_TOP};
        width: 100%;
    }

    .list {
        display: flex;
        flex-direction: column;
        gap: ${LIST_GAP};
        margin: 0;
        padding: 0;

        p {
            margin: 0;
        }
    }

    .list-item {
        .content {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    ul {
        width: 100%;
        flex-grow: 1;
    }

    li {
        margin: 0;
        height: ${LIST_ITEM_HEIGHT};
    }
`;

export const styles = (props: StyledProductBoxProps) => css`
    ${baseStyles(props)}
`;
